/**
 * signupBlockLogger — invio fire-and-forget degli eventi di blocco registrazione
 * verso l'edge function `log-signup-block`.
 *
 * Regole:
 * - MAI bloccante: qualsiasi errore viene ignorato silenziosamente
 * - L'email viene oscurata lato server (mai salvata in chiaro)
 * - Nessuna chiamata durante SSR
 */
import { SUPABASE_CONFIG } from '@/config/supabaseConfig';

const SUPABASE_URL = SUPABASE_CONFIG.URL;
const SUPABASE_ANON_KEY = SUPABASE_CONFIG.ANON_KEY;

export type SignupBlockFlow = 'user_signup' | 'business_registration';

export type SignupBlockReason =
  | 'invalid'
  | 'undeliverable_domain'
  | 'disposable_domain'
  | 'bot_pattern'
  | 'recaptcha_failed'
  | 'recaptcha_low_score'
  | 'recaptcha_missing'
  | 'rate_limited'
  | 'db_rejected'
  | 'signup_error'
  | 'other';

export interface SignupBlockPayload {
  flow: SignupBlockFlow;
  reason: SignupBlockReason;
  detail?: string;
  email?: string;
  score?: number;
  action?: string;
}

export function logSignupBlock(payload: SignupBlockPayload): void {
  if (typeof window === 'undefined' || !SUPABASE_URL) return;

  try {
    void fetch(`${SUPABASE_URL}/functions/v1/log-signup-block`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(SUPABASE_ANON_KEY ? { apikey: SUPABASE_ANON_KEY } : {}),
      },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    // fail-open: il logging non deve mai interferire con la registrazione
  }
}
